import React,{Component} from 'react';
import {Link} from 'react-router'

class NewsContent extends Component{
  constructor(props) {
    super(props)
    this.state = {
      data : {
        news_headline : "",
      }
    }
  }

  componentWillMount() {
    var thisState = this;
    fetch('/serverapi/getnewscontent', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({news_url : this.props.params.news})
      }).then((resp) => resp.json())
        .then(function(data) {
        thisState.setState({ data: data.news[0] })
      });
  }

  render () {
    return(
    <div className="main" style={{ overflow: "scroll"}}>
      <Link to="/news" className="button-times"><i className="fa fa-times fa-2x" /></Link>
      <div className="outer">
        <div className="middle">
          <div className="inner">
            <div className="story row">
              <div className="col-md-2" />
                <div className="col-md-8">
                  <h2 className="text-sm-center">{this.state.data.news_headline}</h2><br/>
                    <div className="text-md-left" dangerouslySetInnerHTML={{__html:this.state.data.news_content}} />
                 </div>
                <div className="col-md-2" />
            </div>
          </div>
        </div>
      </div>
    </div>

    )
  }
}

export default NewsContent;



// WEBPACK FOOTER //
// ./src/pages/NewsContent.js